import { render, staticRenderFns } from "./gcs.vue?vue&type=template&id=ef18846c&scoped=true&"
import script from "./gcs.vue?vue&type=script&lang=js&"
export * from "./gcs.vue?vue&type=script&lang=js&"
import style0 from "./gcs.vue?vue&type=style&index=0&id=ef18846c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef18846c",
  null
  
)

export default component.exports